import { SET_RETIREMENT_DATA } from './actionTypes';

export const setRetirementData = data => {
  return {
    type: SET_RETIREMENT_DATA,
    payload: data,
  };
};
